webpackJsonp([1],{

/***/ "0kd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4I4V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FlmW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HOS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/local-storage/local-storage.js
var local_storage = __webpack_require__("+Y1O");
var local_storage_default = /*#__PURE__*/__webpack_require__.n(local_storage);

// CONCATENATED MODULE: ./src/local-storage/index.js



var local_storage_key = 'ToDoApp';

var local_storage_getToDos = function getToDos(key) {
  var dataJSON = local_storage_default()(key) || '[]';
  return JSON.parse(dataJSON);
};

var local_storage_saveToDos = function saveToDos(key, data) {
  var dataJSON = stringify_default()(data);
  local_storage_default()(key, dataJSON);
};
// CONCATENATED MODULE: ./src/store/mutation-types.js
var UPDATE_TODOS = 'UPDATE_TODOS';
var ADD_TODO = 'ADD_TODO';
var REMOVE_TODO = 'REMOVE_TODO';
var UPDATE_TODO = 'UPDATE_TODO';
// CONCATENATED MODULE: ./src/store/modules/ToDoList.js


var _mutations;




/* harmony default export */ var ToDoList = ({
  namespaced: true,

  getters: {
    toDos: function toDos(state) {
      return state.toDos;
    }
  },

  state: {
    toDos: []
  },

  mutations: (_mutations = {}, defineProperty_default()(_mutations, UPDATE_TODOS, function (state, _ref) {
    var toDos = _ref.toDos;

    state.toDos = toDos;
  }), defineProperty_default()(_mutations, ADD_TODO, function (state, _ref2) {
    var toDo = _ref2.toDo;

    state.toDos.push(toDo);
  }), defineProperty_default()(_mutations, REMOVE_TODO, function (state, _ref3) {
    var id = _ref3.id;

    state.toDos = state.toDos.filter(function (toDo) {
      return toDo.id !== id;
    });
  }), defineProperty_default()(_mutations, UPDATE_TODO, function (state, _ref4) {
    var id = _ref4.id,
        done = _ref4.done;

    var toDo = state.toDos.find(function (toDo) {
      return toDo.id === id;
    });
    toDo.done = done;
  }), _mutations),

  actions: {
    all: function all(_ref5) {
      var commit = _ref5.commit;

      var toDos = local_storage_getToDos(local_storage_key);
      commit(UPDATE_TODOS, { toDos: toDos });
    },

    saveAll: function saveAll(_ref6, toDos) {
      var commit = _ref6.commit;

      local_storage_saveToDos(local_storage_key, toDos);
    },

    add: function add(_ref7, toDo) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit,
          state = _ref7.state;

      commit(ADD_TODO, { toDo: toDo });
      dispatch('saveAll', state.toDos);
    },

    remove: function remove(_ref8, id) {
      var dispatch = _ref8.dispatch,
          commit = _ref8.commit,
          state = _ref8.state;

      commit(REMOVE_TODO, { id: id });
      dispatch('saveAll', state.toDos);
    },

    update: function update(_ref9, _ref10) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit,
          state = _ref9.state;
      var id = _ref10.id,
          done = _ref10.done;

      commit(UPDATE_TODO, { id: id, done: done });
      dispatch('saveAll', state.toDos);
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  strict: true,

  getters: {},

  state: {},

  mutations: {},

  actions: {},

  modules: {
    ToDoList: ToDoList
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoHeader.vue
//
//
//
//
//
//
//

/* harmony default export */ var ToDoHeader = ({
  name: 'ToDoHeader'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040065d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoHeader.vue
var ToDoHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"ToDoHeader"},[_c('h1',{staticClass:"ToDoHeader__h1"},[_vm._v("ToDoApp-Vue")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: ToDoHeader_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ToDoHeader = (esExports);
// CONCATENATED MODULE: ./src/components/ToDoHeader.vue
function injectStyle (ssrContext) {
  __webpack_require__("HOS5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-040065d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ToDoHeader,
  components_ToDoHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoHeader = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoForm.vue

//
//
//
//
//
//



/* harmony default export */ var ToDoForm = ({
  name: 'ToDoForm',
  data: function data() {
    return {
      toDoDescription: '',
      toDoDone: false
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('ToDoList', {
    addToDo: 'add'
  }), {
    handleSubmit: function handleSubmit() {
      var now = Date.now() + '';
      this.addToDo({
        id: now,
        name: 'toDo-' + now,
        description: this.toDoDescription,
        done: this.toDoDone
      });
      this.toDoDescription = '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63daa9a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoForm.vue
var ToDoForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"ToDoForm",attrs:{"method":"POST"},on:{"submit":function($event){$event.preventDefault();_vm.handleSubmit($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDoDescription),expression:"toDoDescription"}],staticClass:"ToDoForm__input",attrs:{"type":"text"},domProps:{"value":(_vm.toDoDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.toDoDescription=$event.target.value}}})])}
var ToDoForm_staticRenderFns = []
var ToDoForm_esExports = { render: ToDoForm_render, staticRenderFns: ToDoForm_staticRenderFns }
/* harmony default export */ var components_ToDoForm = (ToDoForm_esExports);
// CONCATENATED MODULE: ./src/components/ToDoForm.vue
function ToDoForm_injectStyle (ssrContext) {
  __webpack_require__("0kd0")
}
var ToDoForm_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoForm___vue_template_functional__ = false
/* styles */
var ToDoForm___vue_styles__ = ToDoForm_injectStyle
/* scopeId */
var ToDoForm___vue_scopeId__ = "data-v-63daa9a8"
/* moduleIdentifier (server only) */
var ToDoForm___vue_module_identifier__ = null
var ToDoForm_Component = ToDoForm_normalizeComponent(
  ToDoForm,
  components_ToDoForm,
  ToDoForm___vue_template_functional__,
  ToDoForm___vue_styles__,
  ToDoForm___vue_scopeId__,
  ToDoForm___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoForm = (ToDoForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoToggleButton.vue
//
//
//
//


/* harmony default export */ var ToDoToggleButton = ({
  name: 'ToDoToggleButton',
  props: {
    inputId: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d0f3af1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoToggleButton.vue
var ToDoToggleButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"ToDoToggleButton",attrs:{"type":"checkbox","id":_vm.inputId},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}})}
var ToDoToggleButton_staticRenderFns = []
var ToDoToggleButton_esExports = { render: ToDoToggleButton_render, staticRenderFns: ToDoToggleButton_staticRenderFns }
/* harmony default export */ var components_ToDoToggleButton = (ToDoToggleButton_esExports);
// CONCATENATED MODULE: ./src/components/ToDoToggleButton.vue
function ToDoToggleButton_injectStyle (ssrContext) {
  __webpack_require__("XmMu")
}
var ToDoToggleButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoToggleButton___vue_template_functional__ = false
/* styles */
var ToDoToggleButton___vue_styles__ = ToDoToggleButton_injectStyle
/* scopeId */
var ToDoToggleButton___vue_scopeId__ = "data-v-7d0f3af1"
/* moduleIdentifier (server only) */
var ToDoToggleButton___vue_module_identifier__ = null
var ToDoToggleButton_Component = ToDoToggleButton_normalizeComponent(
  ToDoToggleButton,
  components_ToDoToggleButton,
  ToDoToggleButton___vue_template_functional__,
  ToDoToggleButton___vue_styles__,
  ToDoToggleButton___vue_scopeId__,
  ToDoToggleButton___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoToggleButton = (ToDoToggleButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoDescription.vue
//
//
//
//
//
//

/* harmony default export */ var ToDoDescription = ({
  name: 'ToDoDescription',
  props: {
    labelFor: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d781bec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoDescription.vue
var ToDoDescription_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ToDoDescription",attrs:{"for":_vm.labelFor}},[_vm._t("default")],2)}
var ToDoDescription_staticRenderFns = []
var ToDoDescription_esExports = { render: ToDoDescription_render, staticRenderFns: ToDoDescription_staticRenderFns }
/* harmony default export */ var components_ToDoDescription = (ToDoDescription_esExports);
// CONCATENATED MODULE: ./src/components/ToDoDescription.vue
function ToDoDescription_injectStyle (ssrContext) {
  __webpack_require__("PIML")
}
var ToDoDescription_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoDescription___vue_template_functional__ = false
/* styles */
var ToDoDescription___vue_styles__ = ToDoDescription_injectStyle
/* scopeId */
var ToDoDescription___vue_scopeId__ = "data-v-0d781bec"
/* moduleIdentifier (server only) */
var ToDoDescription___vue_module_identifier__ = null
var ToDoDescription_Component = ToDoDescription_normalizeComponent(
  ToDoDescription,
  components_ToDoDescription,
  ToDoDescription___vue_template_functional__,
  ToDoDescription___vue_styles__,
  ToDoDescription___vue_scopeId__,
  ToDoDescription___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoDescription = (ToDoDescription_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoConfirmButton.vue
//
//
//
//
//
//

/* harmony default export */ var ToDoConfirmButton = ({
  name: 'ToDoConfirmButton',
  props: {
    message: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (confirm(this.message)) {
        this.onClick();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553d2a4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoConfirmButton.vue
var ToDoConfirmButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ToDoConfirmButton",on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var ToDoConfirmButton_staticRenderFns = []
var ToDoConfirmButton_esExports = { render: ToDoConfirmButton_render, staticRenderFns: ToDoConfirmButton_staticRenderFns }
/* harmony default export */ var components_ToDoConfirmButton = (ToDoConfirmButton_esExports);
// CONCATENATED MODULE: ./src/components/ToDoConfirmButton.vue
function ToDoConfirmButton_injectStyle (ssrContext) {
  __webpack_require__("4I4V")
}
var ToDoConfirmButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoConfirmButton___vue_template_functional__ = false
/* styles */
var ToDoConfirmButton___vue_styles__ = ToDoConfirmButton_injectStyle
/* scopeId */
var ToDoConfirmButton___vue_scopeId__ = "data-v-553d2a4b"
/* moduleIdentifier (server only) */
var ToDoConfirmButton___vue_module_identifier__ = null
var ToDoConfirmButton_Component = ToDoConfirmButton_normalizeComponent(
  ToDoConfirmButton,
  components_ToDoConfirmButton,
  ToDoConfirmButton___vue_template_functional__,
  ToDoConfirmButton___vue_styles__,
  ToDoConfirmButton___vue_scopeId__,
  ToDoConfirmButton___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoConfirmButton = (ToDoConfirmButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ToDoItem = ({
  name: 'ToDoItem',
  props: {
    toDo: {
      type: Object,
      required: true
    }
  },
  components: {
    ToDoToggleButton: src_components_ToDoToggleButton,
    ToDoDescription: src_components_ToDoDescription,
    ToDoConfirmButton: src_components_ToDoConfirmButton
  },
  computed: {
    toDoId: function toDoId() {
      return this.toDo.id;
    },
    toDoName: function toDoName() {
      return this.toDo.name;
    },
    toDoDescription: function toDoDescription() {
      return this.toDo.description;
    },
    toDoDone: function toDoDone() {
      return this.toDo.done;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('ToDoList', {
    updateToDo: 'update',
    removeToDo: 'remove'
  }), {
    toggleToDoDone: function toggleToDoDone(value) {
      return !value;
    },
    handleToggle: function handleToggle() {
      var id = this.toDoId;
      var done = this.toggleToDoDone(this.toDoDone);
      this.updateToDo({ id: id, done: done });
    },
    handleConfirmation: function handleConfirmation() {
      var id = this.toDoId;
      this.removeToDo(id);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bad9b08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoItem.vue
var ToDoItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToDoItem",class:{ 'ToDoItem--isDone': _vm.toDoDone }},[_c('ToDoToggleButton',{attrs:{"inputId":_vm.toDoName,"checked":_vm.toDoDone,"onChange":_vm.handleToggle},on:{"update:inputId":function($event){_vm.toDoName=$event},"update:checked":function($event){_vm.toDoDone=$event},"update:onChange":function($event){_vm.handleToggle=$event}}}),_vm._v(" "),_c('ToDoDescription',{attrs:{"labelFor":_vm.toDoName},on:{"update:labelFor":function($event){_vm.toDoName=$event}}},[_vm._v("\n      "+_vm._s(_vm.toDoDescription)+"\n  ")]),_vm._v(" "),_c('ToDoConfirmButton',{attrs:{"message":"Are you sure?","onClick":_vm.handleConfirmation},on:{"update:onClick":function($event){_vm.handleConfirmation=$event}}},[_vm._v("\n      ✕\n  ")])],1)}
var ToDoItem_staticRenderFns = []
var ToDoItem_esExports = { render: ToDoItem_render, staticRenderFns: ToDoItem_staticRenderFns }
/* harmony default export */ var components_ToDoItem = (ToDoItem_esExports);
// CONCATENATED MODULE: ./src/components/ToDoItem.vue
function ToDoItem_injectStyle (ssrContext) {
  __webpack_require__("wjeN")
}
var ToDoItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoItem___vue_template_functional__ = false
/* styles */
var ToDoItem___vue_styles__ = ToDoItem_injectStyle
/* scopeId */
var ToDoItem___vue_scopeId__ = "data-v-7bad9b08"
/* moduleIdentifier (server only) */
var ToDoItem___vue_module_identifier__ = null
var ToDoItem_Component = ToDoItem_normalizeComponent(
  ToDoItem,
  components_ToDoItem,
  ToDoItem___vue_template_functional__,
  ToDoItem___vue_styles__,
  ToDoItem___vue_scopeId__,
  ToDoItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoItem = (ToDoItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoList.vue

//
//
//
//
//
//
//
//




/* harmony default export */ var components_ToDoList = ({
  name: 'ToDoList',
  components: {
    ToDoItem: src_components_ToDoItem
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('ToDoList', {
    toDos: 'toDos'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfa7aa2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoList.vue
var ToDoList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ToDoList"},_vm._l((_vm.toDos),function(toDo,key){return _c('li',{key:key,staticClass:"ToDoList__li"},[_c('ToDoItem',{attrs:{"toDo":toDo}})],1)}))}
var ToDoList_staticRenderFns = []
var ToDoList_esExports = { render: ToDoList_render, staticRenderFns: ToDoList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ToDoList = (ToDoList_esExports);
// CONCATENATED MODULE: ./src/components/ToDoList.vue
function ToDoList_injectStyle (ssrContext) {
  __webpack_require__("YDtV")
}
var ToDoList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoList___vue_template_functional__ = false
/* styles */
var ToDoList___vue_styles__ = ToDoList_injectStyle
/* scopeId */
var ToDoList___vue_scopeId__ = "data-v-5cfa7aa2"
/* moduleIdentifier (server only) */
var ToDoList___vue_module_identifier__ = null
var ToDoList_Component = ToDoList_normalizeComponent(
  components_ToDoList,
  selectortype_template_index_0_src_components_ToDoList,
  ToDoList___vue_template_functional__,
  ToDoList___vue_styles__,
  ToDoList___vue_scopeId__,
  ToDoList___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoList = (ToDoList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoPage.vue
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ToDoPage = ({
  name: 'ToDoPage',
  components: {
    ToDoHeader: src_components_ToDoHeader,
    ToDoForm: src_components_ToDoForm,
    ToDoList: src_components_ToDoList
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    store.dispatch('ToDoList/all');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d48ea32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoPage.vue
var ToDoPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToDoPage"},[_c('ToDoHeader',[_c('ToDoForm')],1),_vm._v(" "),_c('ToDoList')],1)}
var ToDoPage_staticRenderFns = []
var ToDoPage_esExports = { render: ToDoPage_render, staticRenderFns: ToDoPage_staticRenderFns }
/* harmony default export */ var components_ToDoPage = (ToDoPage_esExports);
// CONCATENATED MODULE: ./src/components/ToDoPage.vue
function ToDoPage_injectStyle (ssrContext) {
  __webpack_require__("SGcl")
}
var ToDoPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoPage___vue_template_functional__ = false
/* styles */
var ToDoPage___vue_styles__ = ToDoPage_injectStyle
/* scopeId */
var ToDoPage___vue_scopeId__ = "data-v-2d48ea32"
/* moduleIdentifier (server only) */
var ToDoPage___vue_module_identifier__ = null
var ToDoPage_Component = ToDoPage_normalizeComponent(
  ToDoPage,
  components_ToDoPage,
  ToDoPage___vue_template_functional__,
  ToDoPage___vue_styles__,
  ToDoPage___vue_scopeId__,
  ToDoPage___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoPage = (ToDoPage_Component.exports);

// CONCATENATED MODULE: ./src/router/options.js


/* harmony default export */ var options = ({
  routes: [{
    path: '/',
    name: 'ToDoPage',
    component: src_components_ToDoPage
  }]
});
// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */](options));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToDoApp.vue
//
//
//
//
//
//

/* harmony default export */ var ToDoApp = ({
  name: 'ToDoApp'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce48d8be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoApp.vue
var ToDoApp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToDoApp"},[_c('router-view')],1)}
var ToDoApp_staticRenderFns = []
var ToDoApp_esExports = { render: ToDoApp_render, staticRenderFns: ToDoApp_staticRenderFns }
/* harmony default export */ var components_ToDoApp = (ToDoApp_esExports);
// CONCATENATED MODULE: ./src/components/ToDoApp.vue
function ToDoApp_injectStyle (ssrContext) {
  __webpack_require__("FlmW")
  __webpack_require__("SccU")
}
var ToDoApp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ToDoApp___vue_template_functional__ = false
/* styles */
var ToDoApp___vue_styles__ = ToDoApp_injectStyle
/* scopeId */
var ToDoApp___vue_scopeId__ = "data-v-ce48d8be"
/* moduleIdentifier (server only) */
var ToDoApp___vue_module_identifier__ = null
var ToDoApp_Component = ToDoApp_normalizeComponent(
  ToDoApp,
  components_ToDoApp,
  ToDoApp___vue_template_functional__,
  ToDoApp___vue_styles__,
  ToDoApp___vue_scopeId__,
  ToDoApp___vue_module_identifier__
)

/* harmony default export */ var src_components_ToDoApp = (ToDoApp_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.debug = true;
vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(src_components_ToDoApp);
  }
});

/***/ }),

/***/ "PIML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGcl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SccU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XmMu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDtV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wjeN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1c7d6517357f25c05aea.js